import { z } from "zod";

export const optionalNumericString = z.coerce
  .number<string>()
  .optional()
  .catch(undefined);
